import React from 'react';
import { MessageSquare, FileText, CreditCard, Code, Eye, Rocket } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Contacto',
  desc: 'Escríbenos por WhatsApp',
  icon: MessageSquare
}, {
  title: 'Información',
  desc: 'Envíanos tus datos y fotos',
  icon: FileText
}, {
  title: 'Demo',
  desc: 'Solo $25 para empezar',
  icon: CreditCard
}, {
  title: 'Construcción',
  desc: 'Diseñamos tu website',
  icon: Code
}, {
  title: 'Decides',
  desc: 'Te gusta, pagas el resto',
  icon: Eye
}, {
  title: 'Lanzamiento',
  desc: 'Tu página en vivo',
  icon: Rocket
}];
export function ProcessSection() {
  return <section className="py-24 bg-dark-100 overflow-hidden" data-id="element-384" data-mp="1815l7y17h156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-385" data-mp="25hm71qyqkhz5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-386" data-mp="25j5npiob0v1g">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-387" data-mp="2b0o4jodpcdzt">
            Listo En Menos De 72 Horas.{' '}
            <span className="text-gold" data-id="element-388" data-mp="1waqm7p2geiij">Así De Simple.</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-389" data-mp="219bd2xvtfpub">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-dark-100 via-gold/30 to-dark-100 -translate-y-1/2 z-0" data-id="element-390" data-mp="1nabqdvrv5l0s"></div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 relative z-10" data-id="element-391" data-mp="1de8rcysb62i2">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col items-center text-center group" data-id="element-392" data-mp="1idbrc4tflij6" data-mpi={index}>
                <div className="w-16 h-16 rounded-full bg-dark border-2 border-white/10 flex items-center justify-center text-gray-400 group-hover:border-gold group-hover:text-gold group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all duration-300 mb-4 relative" data-id="element-393" data-mp="31dkja1yhghp2">
                  <step.icon className="w-6 h-6" data-id="element-394" data-mp="3p1kkxwxc1sif" />
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-gold text-dark text-xs font-bold rounded-full flex items-center justify-center" data-id="element-395" data-mp="3ka2it5jkplvv">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-white font-bold mb-1" data-id="element-396" data-mp="gmalyxoqp3ev">{step.title}</h3>
                <p className="text-gray-500 text-xs" data-id="element-397" data-mp="busia1vc0oq7">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}